import useFormInstance from "antd/es/form/hooks/useFormInstance";
import FiltersFormValues from "../types/filters-form-values";

export default function useForm() {
  return useFormInstance<FiltersFormValues>();
}
